import React from 'react'

export default function PythonDevIcon() {
   return (
      <svg
         width="57"
         height="57"
         viewBox="0 0 57 57"
         fill="none"
         xmlns="http://www.w3.org/2000/svg"
      >
         <path
            d="M28.1837 0.575409C25.8997 0.586018 23.7187 0.780815 21.7996 1.12042C16.1461 2.11924 15.1196 4.20972 15.1196 8.06508V13.1568H28.4795V14.854H10.1058C6.22308 14.854 2.82315 17.1877 1.75981 21.6274C0.533171 26.7161 0.478812 29.8917 1.75981 35.2053C2.70951 39.1604 4.9774 41.9786 8.86011 41.9786H13.4535V35.8747C13.4535 31.465 17.2689 27.5754 21.7996 27.5754H35.1439C38.8585 27.5754 41.8238 24.5169 41.8238 20.7865V8.06508C41.8238 4.44455 38.7693 1.72472 35.1439 1.12042C32.8489 0.738378 30.4676 0.5648 28.1837 0.575409ZM20.9587 4.67063C22.3387 4.67063 23.4656 5.816 23.4656 7.22421C23.4656 8.62749 22.3387 9.76225 20.9587 9.76225C19.5738 9.76225 18.4519 8.62749 18.4519 7.22421C18.4519 5.81589 19.5738 4.67063 20.9587 4.67063Z"
            fill="#1F473E"
         />
         <path
            d="M43.4904 14.854V20.7865C43.4904 25.3859 39.5909 29.257 35.1444 29.257H21.8001C18.1449 29.257 15.1201 32.3854 15.1201 36.0459V48.7673C15.1201 52.3879 18.2685 54.5175 21.8001 55.5562C26.0291 56.7997 30.0845 57.0245 35.1444 55.5562C38.5078 54.5825 41.8242 52.6227 41.8242 48.7673V43.6756H28.4799V41.9783H48.5042C52.3869 41.9783 53.8338 39.2701 55.1842 35.2051C56.579 31.0201 56.5196 26.9957 55.1842 21.6271C54.2246 17.7618 52.3919 14.8538 48.5042 14.8538H43.4904V14.854ZM35.9853 47.0702C37.3702 47.0702 38.4921 48.2049 38.4921 49.6082C38.4921 51.0165 37.3702 52.1619 35.9853 52.1619C34.6053 52.1619 33.4784 51.0165 33.4784 49.6082C33.4783 48.2049 34.6052 47.0702 35.9853 47.0702Z"
            fill="#1F473E"
         />
      </svg>
   )
}
